module.exports = __webpack_public_path__ + "static/media/wasabix_liquity.2bb89837.png";